import * as React from 'react';
import styled from 'styled-components';
import MuiFormLabel, { FormLabelProps as MuiFormLabelProps } from '@material-ui/core/FormLabel';

const StyledFormLabel = styled(MuiFormLabel)``;

export type DSFormLabelProps = MuiFormLabelProps;
export const DSFormLabel: React.FC<DSFormLabelProps> = StyledFormLabel;
DSFormLabel.displayName = 'DSFormLabel';
